import Queue from 'queue';

import Constants from './Constants';

export default class ImageRegistry {
  private registeredImagesByUrl: object;
  private downloadQueue: Queue;
  private downloadedImages: object;

  constructor() {
    this.registeredImagesByUrl = {};
    this.downloadedImages = {};

    this.downloadQueue = new Queue({
      concurrency: Constants.general.maxConcurrentDownloads,
    });
    this.downloadQueue.start();
  }

  getImage(url) {
    if (url in this.downloadedImages) {
      return this.downloadedImages[url];
    } else {
      return null;
    }
  }

  downloadImage(
    url,
    onsuccess?: (image: HTMLImageElement, url: string) => unknown,
    onerror?: (image: HTMLImageElement, url: string) => unknown,
  ) {
    if (url === null || url in this.downloadedImages) {
      return;
    }

    //this.downloadedImages[url] = null; // register: download in progress (prevent from downloading multiple times)

    this.downloadQueue.push(
      () =>
        new Promise((resolve, reject) => {
          const image = new Image();
          image.src = url;
          image.addEventListener('load', () => {
            this.downloadedImages[url] = image; // download finished
            this.updateRegisteredImages(image, url, true);
            if (onsuccess) onsuccess(image, url);
            resolve(url);
          });
          image.addEventListener('error', event => {
            console.error('could not download image ', url, event);
            // download failed
            if (onerror) onerror(image, url);
            this.updateRegisteredImages(image, url, false);
            reject();
          });
        }),
    );

    this.downloadQueue.start();
  }

  register(url, element) {
    if (!(url in this.registeredImagesByUrl)) {
      this.registeredImagesByUrl[url] = [element];
    } else {
      this.registeredImagesByUrl[url].push(element);
    }
  }

  updateRegisteredImages(image, url, success = true) {
    if (url in this.registeredImagesByUrl) {
      for (const element of this.registeredImagesByUrl[url]) {
        if (success) {
          element.onLoad(image, url);
        } else {
          element.onError(image);
        }
      }
    }
  }
}
